// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/razzle/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._4d02700c384fa01a8e4530ef0ed52e34-scss{padding:1rem}._4d02700c384fa01a8e4530ef0ed52e34-scss ._49bcec13f2077b0bc7c3c4be68910e78-scss{border:1px solid var(--grey-light)}._4d02700c384fa01a8e4530ef0ed52e34-scss ._526b7b0c7a6b5c65216ff441476e2cc1-scss{display:grid;gap:15px;grid-template-columns:repeat(auto-fill, minmax(270px, 1fr))}\n", ""]);
// Exports
exports.locals = {
	"root": "_4d02700c384fa01a8e4530ef0ed52e34-scss",
	"divider": "_49bcec13f2077b0bc7c3c4be68910e78-scss",
	"groupContainer": "_526b7b0c7a6b5c65216ff441476e2cc1-scss"
};
module.exports = exports;
